import { gql } from '@apollo/client';

/**
 * This has no arguments and a single string value return
 * which can be accessed as
 *
 *    response.data.testMutation === 'TEST'
 */
export const TEST_MUTATION = gql`
  mutation testMutation {
    testMutation
  }
`;

export const LOGIN = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        _id
      }
      id
    }
  }
`;

export const CREATE_CHECKOUT_SESSION = gql`
  mutation createCheckout($lines: [OrderLineInput]!, $userId: ID) {
    checkout(lines: $lines, userId: $userId) {
      session
    }
  }
`;

export const ADMIN_UPDATE_LINKS = gql`
  mutation adminUpdateLinks($links: [LinkInput]) {
    adminUpdateLinks(links: $links)
  }
`;

export const ADMIN_UPDATE_CODES = gql`
  mutation adminUpdateCodes($codes: [AliCodeInput]) {
    adminUpdateCodes(codes: $codes)
  }
`;

export const ADMIN_UPDATE_LINK = gql`
  mutation adminUpdateLink($link: LinkInput) {
    adminUpdateLink(link: $link)
  }
`;

export const ADMIN_DELETE_LINK = gql`
  mutation adminDeleteLink($_id: ID!) {
    adminDeleteLink(_id: $_id)
  }
`;

export const ADMIN_UPDATE_LINK_IMAGE = gql`
  mutation adminUpdateLinkImage($_id: ID!, $image: ID) {
    adminUpdateLinkImage(_id: $_id, image: $image) {
      _id
      image
    }
  }
`;

export const ADMIN_UPDATE_LINK_BANNER_IMAGE = gql`
  mutation adminUpdateLinkBannerImage($_id: ID!, $image: ID) {
    adminUpdateLinkBannerImage(_id: $_id, image: $image) {
      _id
      image
    }
  }
`;

export const ADMIN_UPDATE_PRODUCTS = gql`
  mutation adminUpdateProducts($products: [ProductInput]) {
    adminUpdateProducts(products: $products)
  }
`;

export const ADD_USER = gql`
  mutation addUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
  ) {
    addUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
    ) {
      token
      user {
        _id
      }
    }
  }
`;

export const UPDATE_POST = gql`
  mutation updatePost(
    $_id: ID
    $title: String
    $post: String
    $image: String
    $active: Boolean
    $productLink: String
  ) {
    addOrUpdatePost(
      _id: $_id
      title: $title
      post: $post
      image: $image
      active: $active
      productLink: $productLink
    ) {
      _id
      title
      post
      image
      active
      productLink
    }
  }
`;

export const ADD_IMAGE = gql`
  mutation addImage(
    $filename: String
    $mimeType: String
  ) {
    addImage(
      filename: $filename
      mimeType: $mimeType
    ) {
      _id
      filename
      mimeType
      signedUploadUrl
    }
  }
`;

export const SET_IMAGE_UPLOADED = gql`
  mutation setImageUploaded($_id: ID!) {
    setImageUploaded(_id: $_id) {
      _id
    }
  }
`;

export const ADD_EMAIL = gql`
  mutation addEmail($email: String!, $source: String) {
    addEmail(email: $email, source: $source)
  }
`;
